import React, { useEffect } from "react"
import types from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import {
  initialize as initializeCustomNamesSlice,
  initializing as initializingCustomNames,
} from "reduxSlices/customNamesSlice"
import LoadingIndicator from "shared/LoadingIndicator"
import withReduxProvider from "shared/withReduxProvider"
import AddCustomName from "./AddCustomName"
import CustomNamesList from "./CustomNamesList"

const ManageCustomNames = ({ organizationSubdomain }) => {
  const dispatch = useDispatch()
  const initializing = useSelector(initializingCustomNames)

  useEffect(() => {
    dispatch(initializeCustomNamesSlice({ organizationSubdomain }))
  }, [dispatch, organizationSubdomain])

  if (initializing) {
    return (
      <LoadingIndicator textValue="Loading custom names ..." />
    )
  }

  return (
    <div className="flex flex-col gap-4">
      <CustomNamesList />
      <AddCustomName />
    </div>
  )
}

ManageCustomNames.propTypes = {
  organizationSubdomain: types.string.isRequired,
}

export default withReduxProvider(ManageCustomNames)
